import { useCallback, useMemo } from 'react';

import moment, { type Moment } from 'moment';

import isArray from 'lodash/isArray';

import { DatePickerField } from 'src/components/DatePickerField';
import { toMoment, toString as toDateString } from 'src/utils/datetime';

interface DateRangeFieldProps {
  field: UCM.DynamicFieldType;
  onChange: (
    field: UCM.DynamicFieldType,
    value: { value: string | null },
  ) => void;
  value: ({ value: string } & string) | null | undefined;
}

export default function DateField({
  field,
  value,
  onChange,
  ...others
}: DateRangeFieldProps) {
  const handleDateChange = useCallback(
    (date: Moment | Array<Moment> | null) => {
      if (isArray(date)) return Promise.resolve();
      onChange(field, { value: toDateString(date, moment.HTML5_FMT.DATE) });

      return Promise.resolve();
    },
    [],
  );

  const formattedValue = useMemo(() => {
    return toMoment(value?.value || value, moment.HTML5_FMT.DATE);
  }, [value?.value || value]);

  return (
    <DatePickerField
      {...others}
      allowPicker
      allowTyping
      onChange={handleDateChange}
      onBlurChange={handleDateChange}
      value={formattedValue}
    />
  );
}
